import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { Home, Calendar, Users, Flag, Box, Megaphone, BarChart3, Settings, Search, HelpCircle, ChevronDown, UserRound } from 'lucide-react'
import { logOutPlatform } from '../lib/platformAuth.js'
import logo from '../assets/brand/golf-elite-logo-full.png'

// Golf Elite shared admin chrome — a TOP navigation bar (no sidebar). Rendered
// once by AdminShell on every /admin route. Full labels per spec.
const NAV = [
  { key: 'home', label: 'Home', to: '/admin', Icon: Home },
  { key: 'events', label: 'Events', to: '/admin/pbcc-4ball', Icon: Calendar },
  { key: 'golfers', label: 'Golfers', to: '/admin/gg/members', Icon: Users },
  { key: 'courses', label: 'Courses & Handicaps', to: '/admin/club-data', Icon: Flag },
  { key: 'golfgames', label: 'Golf Games', to: '/admin/gg-features', Icon: Box },
  { key: 'advertising', label: 'Advertising', to: '/admin/advertising', Icon: Megaphone },
  { key: 'reports', label: 'Reports', to: '/admin/order-of-merit', Icon: BarChart3 },
  { key: 'settings', label: 'Settings', to: '/admin/gg/settings', Icon: Settings },
]

function activeKey(p) {
  if (p === '/admin' || p === '/admin/') return 'home'
  if (p.startsWith('/admin/gg/members')) return 'golfers'
  if (p.startsWith('/admin/gg/settings')) return 'settings'
  if (p.startsWith('/admin/gg-features') || p.startsWith('/admin/gg/formats') || p.startsWith('/admin/gg/multi-format') || p.startsWith('/admin/gg/games')) return 'golfgames'
  if (p.startsWith('/admin/club-data') || p.startsWith('/admin/courses')) return 'courses'
  if (p.startsWith('/admin/advertising')) return 'advertising'
  if (p.startsWith('/admin/order-of-merit')) return 'reports'
  if (p.startsWith('/admin/pbcc-4ball') || p.startsWith('/admin/t/') || p.startsWith('/admin/qualifying') || p.startsWith('/admin/calcutta')) return 'events'
  return ''
}

export default function GeTopNav() {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [acct, setAcct] = useState(false)
  const active = activeKey(pathname)
  return (
    <header className="ge-topnav">
      <Link to="/admin" className="ge-tn-logo" aria-label="Golf Elite — Home">
        <img className="ge-tn-logo-img" src={logo} alt="Golf Elite" />
      </Link>
      <nav className="ge-tn-items">
        {NAV.map((it) => (
          <Link key={it.key} to={it.to} className={`ge-tn-item ${it.key === active ? 'is-active' : ''}`}>
            <it.Icon size={25} strokeWidth={2} />
            <span>{it.label}</span>
          </Link>
        ))}
      </nav>
      <div className="ge-tn-right">
        <button type="button" className="ge-tn-ic" aria-label="Search" onClick={() => navigate('/admin/pbcc-4ball')}><Search size={20} strokeWidth={2.2} /></button>
        <Link to="/admin/gg/settings" className="ge-tn-help" aria-label="Help"><HelpCircle size={18} strokeWidth={2.4} /></Link>
        <div className="ge-tn-acct">
          <button type="button" className="ge-tn-acct-btn" onClick={() => setAcct((o) => !o)}>
            <span className="ge-tn-avatar"><UserRound size={18} strokeWidth={2} /></span>
            <span className="ge-tn-acct-name">My Account</span>
            <ChevronDown size={16} strokeWidth={2.4} />
          </button>
          {acct ? (
            <>
              <div className="ge-acct-backdrop" onClick={() => setAcct(false)} />
              <div className="ge-acct-menu">
                <Link to="/billing" className="ge-acct-item" onClick={() => setAcct(false)}>Billing</Link>
                <button type="button" className="ge-acct-item" onClick={() => { setAcct(false); logOutPlatform() }}>Sign out</button>
              </div>
            </>
          ) : null}
        </div>
      </div>
    </header>
  )
}
